import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.977 11.108a4.987 4.987 0 1 0 2.534 8.442l1.066-1.201a1 1 0 1 1 1.496 1.328l-1.088 1.225-.04.043a6.987 6.987 0 1 1 .04-9.846l7.505 8.451a4.988 4.988 0 1 0 0-7.1l-1.067 1.202a1 1 0 1 1-1.496-1.328l1.088-1.225.041-.044a6.988 6.988 0 1 1-.041 9.847L11.51 12.45a5 5 0 0 0-2.534-1.342"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconInfinity = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconInfinity);
export default Memo;
